// Load Styles
import '../scss/main.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
 
import "@glidejs/glide/dist/css/glide.core.css";
import "@glidejs/glide/dist/css/glide.theme.css";


// import Glide from '@glidejs/glide/dist/glide.modular.esm.js'
import Glide from '@glidejs/glide'



// Load Bootstrap init
import {initBootstrap} from "./bootstrap.js";

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';


import ScrollMagic from "scrollmagic"
import {TimelineMax , Linear, TweenMax} from "gsap"
import { ScrollMagicPluginIndicator,ScrollMagicPluginGsap} from "scrollmagic-plugins";
 
ScrollMagicPluginIndicator(ScrollMagic);
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

var mySwiper
 
initBootstrap({
  tooltip: true,
	
});

 


document.addEventListener("DOMContentLoaded", function() {

	// Get references to both elements
const button = document.querySelector('.navigation__button');
const bg = document.querySelector('.navigation__background');

// Function to update the position of .navigation__bg to match .navigation__button
function updateBackgroundPosition() {
  const buttonRect = button.getBoundingClientRect();

  // Set the position of .navigation__bg to match .navigation__button
  bg.style.left = buttonRect.left + 'px';
  bg.style.top = buttonRect.top + 'px';
  bg.style.width = buttonRect.width + 'px';
  bg.style.height = buttonRect.height + 'px';
}

// Call the function initially and whenever the window is resized
updateBackgroundPosition();
window.addEventListener('resize', updateBackgroundPosition);




const masthead = document.querySelector('#masthead');

// Function to toggle the "scrolled" class based on scroll position
function toggleScrolledClass() {
  if (window.scrollY > 400) {
    masthead.classList.add('scrolled');
  } else {
    masthead.classList.remove('scrolled');
  }
}

// Listen for the scroll event and toggle the class
window.addEventListener('scroll', toggleScrolledClass);

// Call the function initially to set the initial state
toggleScrolledClass();

document.querySelectorAll(".navigation__nav a").forEach(e => {
	e.addEventListener('click', evt => {
	  document.getElementById('nav-toggle').checked = false;;
	});
  });
  
    // Get the list of <li> elements
    const listItems = document.querySelectorAll("#keyfocus ul li");

    // Define the Intersection Observer callback function
    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // The <li> element is in the viewport
                entry.target.classList.add("inview");
                // You can add your desired actions here
            } else {
                // The <li> element is not in the viewport
                entry.target.classList.remove("inview");
                // You can add your desired actions here
            }
        });
    };

    // Create an Intersection Observer instance
    const observer = new IntersectionObserver(callback);

    // Attach the observer to each <li> element
    listItems.forEach((item) => {
        observer.observe(item);
    });




	const tabLinks = document.querySelectorAll('.list-group-item');

	tabLinks.forEach((link) => {
		link.addEventListener('mouseenter', function () {
			link.click(); // Simulate a click to activate the tab
		});
	});

	  initSliders();
});



var controller = new ScrollMagic.Controller();
 

		 
			// init
			var controller = new ScrollMagic.Controller({
				globalSceneOptions: {
					triggerHook: 'onLeave',
					duration: "90%" // this works just fine with duration 0 as well
  				}
			});
	
			// get all slides
			var slides = document.querySelectorAll(".sections .section");
	
			// create scene for every slide
			for (var i=0; i<slides.length; i++) {
				new ScrollMagic.Scene({
						triggerElement: slides[i]
					})
					.setPin(slides[i], {pushFollowers: false})
					// .addIndicators()  
					// .addTo(controller);
			}

			
			 
			// var controllerEnter = new ScrollMagic.Controller({
			// 		triggerHook: 'onEnter',
			// 		duration: "150%" // this works just fine with duration 0 as well
  				 
			// });
			// document.getElementById("keyfocus").querySelectorAll('li').forEach(function(e){
			// 	new ScrollMagic.Scene({
			// 					triggerElement: "#keyfocus"
			// 	 })
			// 	 .setTween(e, {  opacity: 1 ,scale:1})  .addIndicators()  
			// 	 .addTo(controllerEnter);
			// })
			


			var h1 = document.getElementById("masked");
			var mask = document.querySelector(".lense");
			var isTracking = false;
			var targetX = -999; // Initial off-screen position
			var targetY = 0;
			var currentX = -999;
			var currentY = 0;
			var transitionSpeed = 0.03; // Adjust the transition speed as needed
	  
			document.addEventListener("mousemove", function (e) {
			  if (!isTracking) {
				isTracking = true;
				setTimeout(function () {
				  targetX = e.clientX;
				  targetY = e.clientY;
				  isTracking = false;
				}, 5);
			  }
			});
	  
			function animateMask() {
			  var dx = targetX - currentX;
			  var dy = targetY - currentY;
	  
			  currentX += dx * transitionSpeed;
			  currentY += dy * transitionSpeed;
	  
			  setMaskPos(currentX, currentY);
	  
			  requestAnimationFrame(animateMask);
			}
	  
			function setMaskPos(x, y) {
				
			  mask.style.transform = "translate(" + x + "px, " + y + "px)";
			  h1.style.webkitMaskImage =
				"radial-gradient(circle at " +
				x +
				"px " +
				y +
				"px, black 0px, black 6vw, transparent 8vw)";
			}
	  
			// Initialize the mask off-screen and start animation
			animateMask();

	
	 

			function initSliders() {
				var g = new Glide('#intro', {
					animationDuration: 1000,
					type: 'carousel',
					perView: 4,
					focusAt: 'center',
					autoplay:5000,
					breakpoints: {
						1920: {
							perView: 7
						},
						1300: {
							perView: 4
						},
						800: {
							perView: 2
						},
						480: {
							perView: 1.5
						}
					}
				});
			
				// Add an event listener to the "run.before" event
				g.on('run.before', function () {
					// Add the "moving" class to all slides before the transition starts
					document.querySelectorAll('.glide__slide').forEach(function (slide) {
						slide.classList.add('moving');
					});
				});
			
				// Add another event listener to the "run.after" event to remove the class
				g.on('run.after', function () {
					// Remove the "moving" class from all slides after the transition completes
					document.querySelectorAll('.glide__slide').forEach(function (slide) {
						slide.classList.remove('moving');
					});
				});
			
				// Add click event listeners to all slides
				document.querySelectorAll('.glide__slide').forEach(function (slide, index) {
					slide.addEventListener('click', function () {
						// Move to the clicked slide
						g.go('=' + index); // Use the Glide.js API to move to the desired slide
					});
				});
			
				// Mount the Glide carousel
				g.mount();
			}
			

 